import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube } from "lucide-react";
import { LOGO_URL } from "@/lib/pfc";
import NewsletterSignup from "@/components/NewsletterSignup";

export default function Footer() {
  return (
    <footer className="bg-ink-900 border-t border-white/10 mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16">
        {/* Newsletter band */}
        <div className="pfc-card p-8 lg:p-12 mb-16 relative overflow-hidden splatter-red" data-testid="footer-newsletter-band">
          <div className="relative grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <div className="label text-pfc-gold mb-3">The PFC Weekly</div>
              <h3 className="font-display text-3xl lg:text-4xl text-white uppercase leading-[0.95]">
                Sunday-night dispatch from the <span className="gold-text">culture front line</span>.
              </h3>
              <p className="text-white/65 mt-4 font-body text-sm">
                Cover stories, breakout talent, exclusive event invites. One email a week. No fluff.
              </p>
            </div>
            <NewsletterSignup source="footer" variant="inline" />
          </div>
        </div>

        <div className="grid lg:grid-cols-4 gap-12">
          <div>
            <img src={LOGO_URL} alt="PFC" className="h-20 w-20 object-contain mb-4" />
            <p className="font-display text-2xl gold-text leading-none mb-2">PROMOTING TALENT.</p>
            <p className="font-display text-2xl silver-text leading-none mb-2">ELEVATING BRANDS.</p>
            <p className="font-display text-2xl gold-text leading-none">INSPIRING THE WORLD.</p>
          </div>
          <div>
            <div className="label text-pfc-gold mb-4">Explore</div>
            <ul className="space-y-2 text-white/70 font-body text-sm">
              <li><Link to="/magazine" className="hover:text-pfc-gold">Magazine</Link></li>
              <li><Link to="/directory" className="hover:text-pfc-gold">Public Figure Directory</Link></li>
              <li><Link to="/film" className="hover:text-pfc-gold">Film & Entertainment</Link></li>
              <li><Link to="/events" className="hover:text-pfc-gold">Events</Link></li>
              <li><Link to="/press" className="hover:text-pfc-gold">Press Releases</Link></li>
            </ul>
          </div>
          <div>
            <div className="label text-pfc-gold mb-4">Get Featured</div>
            <ul className="space-y-2 text-white/70 font-body text-sm">
              <li><Link to="/submit" className="hover:text-pfc-gold">Submit Your Story</Link></li>
              <li><Link to="/pricing" className="hover:text-pfc-gold">Featured Packages</Link></li>
              <li><Link to="/services" className="hover:text-pfc-gold">Production Services</Link></li>
              <li><Link to="/contact" className="hover:text-pfc-gold">Advertising Inquiries</Link></li>
              <li><Link to="/contact" className="hover:text-pfc-gold">Press & Partnerships</Link></li>
              <li><Link to="/register" className="hover:text-pfc-gold">Create Profile</Link></li>
            </ul>
          </div>
          <div>
            <div className="label text-pfc-gold mb-4">Connect</div>
            <div className="flex gap-3 mb-6">
              <a href="#" className="w-10 h-10 grid place-items-center border border-white/15 hover:border-pfc-gold hover:text-pfc-gold transition" aria-label="Instagram"><Instagram size={16} /></a>
              <a href="#" className="w-10 h-10 grid place-items-center border border-white/15 hover:border-pfc-gold hover:text-pfc-gold transition" aria-label="Twitter"><Twitter size={16} /></a>
              <a href="#" className="w-10 h-10 grid place-items-center border border-white/15 hover:border-pfc-gold hover:text-pfc-gold transition" aria-label="YouTube"><Youtube size={16} /></a>
            </div>
            <p className="text-white/50 text-xs font-body">hello@publicfigurescampaign.com</p>
            <p className="text-white/40 text-xs font-body mt-1">www.publicfigurescampaign.com</p>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-white/40 text-xs font-sub uppercase tracking-[0.2em]">
          <span>© 2026 Public Figures Campaign</span>
          <span>MUSIC · MEDIA · SPORTS · CULTURE · VIRAL</span>
        </div>
      </div>
    </footer>
  );
}
